<h1 mat-dialog-title>Art und Umfang der Prüfung</h1>
<mat-dialog-content>
    <form [formGroup]="checkForm" class="new-check-dialog-form">
        <mat-form-field>
            <mat-label>Bezeichnung</mat-label>
            <input matInput placeholder="(FB / LP / Titel)" formControlName="displayName">
            @if (checkForm.get('displayName')?.touched && checkForm.get('displayName')?.invalid) {
                <mat-error>{{ getErrorMessage('displayName') }}</mat-error>
            }
        </mat-form-field>
        <div class="source-type-toggle">
            <label class="source-type-label">Speicherort</label>
            <mat-button-toggle-group [value]="sourceType()" (change)="onSourceTypeChange($event.value)">
                <mat-button-toggle value="sharepoint">SharePoint</mat-button-toggle>
                <mat-button-toggle value="directoryP">Laufwerk P:\</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        @if (sourceType() === 'sharepoint') {
        <mat-form-field>
            <mat-label>Sharepoint Ordner</mat-label>
            <input matInput placeholder="" formControlName="sharepointFolderPath">
            @if (checkForm.get('sharepointFolderPath')?.touched && checkForm.get('sharepointFolderPath')?.invalid) {
                <mat-error>{{ getErrorMessage('sharepointFolderPath') }}</mat-error>
            }
        </mat-form-field>
        }
        @if (sourceType() === 'directoryP') {
        <mat-form-field>
            <mat-label>Pfad auf P:/</mat-label>
            <input matInput placeholder="" formControlName="directoryPFolderPath">
            @if (checkForm.get('directoryPFolderPath')?.touched && checkForm.get('directoryPFolderPath')?.invalid) {
                <mat-error>{{ getErrorMessage('directoryPFolderPath') }}</mat-error>
            }
        </mat-form-field>
        }
        @if (checkForm.hasError('exclusivePath')) {
            <span class="exclusive-path-error">Bitte nur einen Speicherort angeben (SharePoint oder Laufwerk P).</span>
        }
        <mat-form-field>
            <mat-label>Ersteller / Prüfer Kontrolle 1-1</mat-label>
            <input matInput placeholder="" value="Aktueller Nutzer" disabled>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Prüffrist 1</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="dueDate" required>
          <mat-hint>TT.MM.JJJJ</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          @if (checkForm.get('dueDate')?.touched && checkForm.get('dueDate')?.invalid) {
              <mat-error>{{ getErrorMessage('dueDate') }}</mat-error>
          }
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="new-check-dialog-save-button">
    <button mat-button (click)="closeDialog()">
        Abbrechen
    </button>
    <button mat-raised-button
            color="primary"
            (click)="createCheck()"
            [disabled]="checkForm.invalid">
        Erstellen
    </button>
</mat-dialog-actions>
